// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__hGOjX","qrContainer":"Footer_qrContainer__XTeIW"};